<template>
	<v-dialog
		v-model="dialog"
		max-width="968"
		:fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
		:transition="$vuetify.breakpoint.smAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-history</v-icon>
				履歴確認
			</v-btn>
		</template>
		<v-card :tile="$vuetify.breakpoint.smAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 履歴確認 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<div class="table-container">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<template v-if="$vuetify.breakpoint.mdAndUp">
								<tr>
									<th class="font-weight-bold" width="20%">材料名</th>
									<td colspan="5">XXX</td>
								</tr>
								<tr v-if="type == 'rubber'">
									<th class="font-weight-bold" width="20%">ロット</th>
									<td width="30%">XXX</td>
									<th class="font-weight-bold" width="10%">厚み</th>
									<td width="15%">XXX</td>
									<th class="font-weight-bold" width="10%">幅</th>
									<td width="15%">XXX</td>
								</tr>
								<tr v-if="type == 'item_kg'">
									<th class="font-weight-bold" width="20%">ロット</th>
									<td width="30%">XXX</td>
									<th class="font-weight-bold" width="20%">入り目(kg)</th>
									<td width="30%">XXX</td>
								</tr>
								<tr v-if="type == 'item_quantity'">
									<th class="font-weight-bold" width="20%">ロット</th>
									<td width="80%">XXX</td>
								</tr>
							</template>
							<template v-else>
								<tr>
									<th class="font-weight-bold" width="30%">材料名</th>
									<td width="70%">XXX</td>
								</tr>
								<tr>
									<th class="font-weight-bold" width="30%">ロット</th>
									<td width="70%">XXX</td>
								</tr>
								<template v-if="type == 'rubber'">
									<tr>
										<th class="font-weight-bold" width="30%">厚み</th>
										<td width="70%">XXX</td>
									</tr>
									<tr>
										<th class="font-weight-bold" width="30%">幅</th>
										<td width="70%">XXX</td>
									</tr>
								</template>
								<template v-if="type == 'item_kg'">
									<tr>
										<th class="font-weight-bold" width="20%">ロット</th>
										<td width="80%">XXX</td>
									</tr>
									<tr>
										<th class="font-weight-bold" width="20%">入り目(kg)</th>
										<td width="80%">XXX</td>
									</tr>
								</template>
								<template v-if="type == 'item_quantity'">
									<tr>
										<th class="font-weight-bold" width="20%">ロット</th>
										<td width="80%">XXX</td>
									</tr>
								</template>
							</template>
						</tbody>
					</table>

					<table width="100%" class="show-dialog-table mt-4">
						<tbody>
							<tr>
								<th class="font-weight-bold">項目名</th>
								<th class="font-weight-bold">変更内容</th>
								<th class="font-weight-bold">変更理由</th>
								<th class="font-weight-bold">変更者</th>
								<th class="font-weight-bold">変更日</th>
							</tr>
						</tbody>
						<tbody>
							<!-- v-for="(履歴, i) in 全履歴" :key="i" -->
							<tr>
								<td>XXX</td>
								<td>XXXXX</td>
								<td>XXXXXXX</td>
								<td>XX XX</td>
								<td>XXXX/XX/XX</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters justify="end">
					<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
						閉じる
					</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"
import common from "../../../helper/common"

export default {
	props: {
		type: {
			type: String,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			dialog: false,
			rules,
			common,
		}
	},
	methods: {
		closeDialog() {
			this.dialog = false
		},
	},
}
</script>